module.exports = __webpack_public_path__ + "media/v2/components/shared/Image/noGamesIcons/noGamesJoined/nfl/survive_wt-30aa5457a7222c1e8fef341081d3faca.svg";